var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "nav",
    {
      ref: "site_header",
      staticClass: "site_header",
      class: { scrolled: _vm.isScrolled },
      style: {
        "--nav-index": this.$store.state.nav_index_toggle ? "810" : "830",
      },
    },
    [
      _vm.toggle_alert_banner
        ? _c("alert-banner", {
            attrs: {
              alert_banner_link: _vm.alert_banner_link,
              alert_banner_text: _vm.alert_banner_text,
              alert_banner_id: _vm.alert_banner_id,
            },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "top_menu" }, [
        _c("div", { staticClass: "container" }, [
          _c("div", { staticClass: "secondary_menu" }, [
            _c(
              "div",
              { staticClass: "search", on: { click: _vm.toggleSearch } },
              [
                _c(
                  "svg",
                  {
                    attrs: {
                      width: "18",
                      height: "18",
                      viewBox: "0 0 18 18",
                      fill: "none",
                      xmlns: "http://www.w3.org/2000/svg",
                    },
                  },
                  [
                    _c("path", {
                      attrs: {
                        "fill-rule": "evenodd",
                        "clip-rule": "evenodd",
                        d: "M7.85544 2.44576C4.72582 2.44576 2.18877 4.98281 2.18877 8.11242C2.18877 11.2421 4.72581 13.7791 7.85544 13.7791C9.31113 13.7791 10.6386 13.2302 11.6422 12.3281L12.0711 11.8992C12.9732 10.8956 13.5221 9.56811 13.5221 8.11242C13.5221 4.9828 10.9851 2.44576 7.85544 2.44576ZM13.9376 12.7804C14.9313 11.4876 15.5221 9.86903 15.5221 8.11242C15.5221 3.87825 12.0897 0.445755 7.85544 0.445755C3.62125 0.445755 0.188766 3.87824 0.188766 8.11242C0.188766 12.3467 3.62126 15.7791 7.85544 15.7791C9.61204 15.7791 11.2307 15.1883 12.5234 14.1946L16.1888 17.86L17.603 16.4458L13.9376 12.7804Z",
                        fill: "#4F58F5",
                      },
                    }),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            _vm.parsedMenu
              ? _c(
                  "ul",
                  _vm._l(_vm.parsedSecondaryMenu, function (menu_item, index) {
                    return _c("secondary-menu-item", {
                      key: index,
                      attrs: {
                        menu_item: menu_item,
                        "has-children": menu_item.children ? true : false,
                        selected: menu_item.object_id == Number(_vm.currentId),
                        locale: _vm.locale,
                        theme: menu_item["classes"].includes("portal_logins")
                          ? "portal"
                          : "top",
                      },
                    })
                  }),
                  1
                )
              : _vm._e(),
          ]),
        ]),
      ]),
      _vm._v(" "),
      _vm.window.width >= 1240
        ? _c("div", { staticClass: "desktop_menu container alt" }, [
            _c(
              "a",
              { staticClass: "site_header-brand", attrs: { href: "/" } },
              [
                _c("img", {
                  attrs: {
                    src: _vm.parsedGlobalSettings.general.logo
                      ? _vm.parsedGlobalSettings.general.logo
                      : _vm.logo,
                    alt: "Property Insurance People",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "center" }, [
              _vm.parsedMenu
                ? _c(
                    "ul",
                    [
                      _vm._l(_vm.parsedMenu, function (menu_item, index) {
                        return [
                          menu_item.classes.includes("mega-menu")
                            ? _c("menu-item", {
                                key: index + "_mega",
                                attrs: {
                                  menu_item: menu_item,
                                  "has-children": menu_item.children
                                    ? true
                                    : false,
                                  selected:
                                    menu_item.object_id ==
                                    Number(_vm.currentId),
                                  locale: _vm.locale,
                                  "nav-height": _vm.height,
                                },
                                on: { menuShow: _vm.toggleOverlay },
                              })
                            : _c("secondary-menu-item", {
                                key: index,
                                attrs: {
                                  menu_item: menu_item,
                                  "has-children": menu_item.children
                                    ? true
                                    : false,
                                  selected:
                                    menu_item.object_id ==
                                    Number(_vm.currentId),
                                  locale: _vm.locale,
                                },
                              }),
                        ]
                      }),
                    ],
                    2
                  )
                : _vm._e(),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _vm.parsedGlobalSettings.general.cta_two
                  ? _c("secondary-button", {
                      attrs: {
                        link: _vm.parsedGlobalSettings.general.cta_two,
                        label: _vm.parsedGlobalSettings.general.cta_two.title,
                        target: _vm.parsedGlobalSettings.general.cta_two.target,
                        theme: "mob-menu",
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.parsedGlobalSettings.general
                  ? _c("primary-button", {
                      attrs: {
                        link: _vm.parsedGlobalSettings.general.cta,
                        label: _vm.parsedGlobalSettings.general.cta.title,
                        target: _vm.parsedGlobalSettings.general.cta.target,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "bounce" } }, [
        _vm.window.width >= 1240 && _vm.isScrolled
          ? _c("div", { staticClass: "desktop_menu scrolled" }, [
              _c("div", { staticClass: "container alt" }, [
                _c(
                  "a",
                  { staticClass: "site_header-brand", attrs: { href: "/" } },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.parsedGlobalSettings.general.logo
                          ? _vm.parsedGlobalSettings.general.logo
                          : _vm.logo,
                        alt: "Property Insurance People",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c("div", { staticClass: "center" }, [
                  _vm.parsedMenu
                    ? _c(
                        "ul",
                        [
                          _vm._l(_vm.parsedMenu, function (menu_item, index) {
                            return [
                              menu_item.classes.includes("mega-menu")
                                ? _c("menu-item", {
                                    key: index + "_mega",
                                    attrs: {
                                      menu_item: menu_item,
                                      "has-children": menu_item.children
                                        ? true
                                        : false,
                                      selected:
                                        menu_item.object_id ==
                                        Number(_vm.currentId),
                                      locale: _vm.locale,
                                    },
                                  })
                                : _c("secondary-menu-item", {
                                    key: index,
                                    attrs: {
                                      menu_item: menu_item,
                                      "has-children": menu_item.children
                                        ? true
                                        : false,
                                      selected:
                                        menu_item.object_id ==
                                        Number(_vm.currentId),
                                      locale: _vm.locale,
                                    },
                                  }),
                            ]
                          }),
                        ],
                        2
                      )
                    : _vm._e(),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _vm.parsedGlobalSettings.general.cta_two
                      ? _c("secondary-button", {
                          attrs: {
                            link: _vm.parsedGlobalSettings.general.cta_two,
                            label:
                              _vm.parsedGlobalSettings.general.cta_two.title,
                            target:
                              _vm.parsedGlobalSettings.general.cta_two.target,
                            theme: "mob-menu",
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.parsedGlobalSettings.general
                      ? _c("primary-button", {
                          attrs: {
                            link: _vm.parsedGlobalSettings.general.cta,
                            label: _vm.parsedGlobalSettings.general.cta.title,
                            target: _vm.parsedGlobalSettings.general.cta.target,
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.isScrolled && _vm.window.width < 1240
        ? _c("div", { staticClass: "mobile_menu_nav container alt" }, [
            _c(
              "a",
              { staticClass: "site_header-brand", attrs: { href: "/" } },
              [
                _c("img", {
                  attrs: {
                    src: _vm.parsedGlobalSettings.general.logo
                      ? _vm.parsedGlobalSettings.general.logo
                      : _vm.logo,
                    alt: "Property Insurance People",
                  },
                }),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "right" },
              [
                _vm.parsedGlobalSettings
                  ? _c("primary-button", {
                      attrs: {
                        link: _vm.parsedGlobalSettings.general.cta,
                        label: _vm.parsedGlobalSettings.general.cta.title,
                        target: _vm.parsedGlobalSettings.general.cta.target,
                      },
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm._l(_vm.parsedSecondaryMenu, function (menu_item, index) {
                  return [
                    menu_item["classes"].includes("portal_logins")
                      ? _c("secondary-menu-item", {
                          key: index,
                          attrs: {
                            menu_item: menu_item,
                            "has-children": menu_item.children ? true : false,
                            selected:
                              menu_item.object_id == Number(_vm.currentId),
                            locale: _vm.locale,
                            type: "mobile",
                            theme: menu_item["classes"].includes(
                              "portal_logins"
                            )
                              ? "portal"
                              : "top",
                          },
                        })
                      : _vm._e(),
                  ]
                }),
                _vm._v(" "),
                _vm.parsedGlobalSettings.general.portal_login
                  ? _c(
                      "a",
                      {
                        staticClass: "portal_link",
                        attrs: {
                          href: _vm.parsedGlobalSettings.general.portal_login
                            .url,
                          target:
                            _vm.parsedGlobalSettings.general.portal_login
                              .target,
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "15",
                              height: "18",
                              viewBox: "0 0 15 18",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M4.64624 3.90342C4.64624 2.43048 5.8403 1.23642 7.31324 1.23642C8.78618 1.23642 9.98024 2.43048 9.98024 3.90342C9.98024 5.37636 8.78618 6.57042 7.31324 6.57042C5.8403 6.57042 4.64624 5.37636 4.64624 3.90342ZM7.31324 0.23642C5.28801 0.23642 3.64624 1.87819 3.64624 3.90342C3.64624 5.92865 5.28801 7.57042 7.31324 7.57042C9.33847 7.57042 10.9802 5.92865 10.9802 3.90342C10.9802 1.87819 9.33847 0.23642 7.31324 0.23642ZM3.00352 12.0927C4.08579 11.0104 5.55367 10.4024 7.08423 10.4024H7.54223C9.0728 10.4024 10.5407 11.0104 11.6229 12.0927C12.7052 13.175 13.3132 14.6429 13.3132 16.1734C13.3132 16.226 13.3029 16.278 13.2828 16.3265C13.2627 16.375 13.2332 16.4191 13.1961 16.4563C13.1589 16.4934 13.1148 16.5229 13.0663 16.543C13.0178 16.5631 12.9658 16.5734 12.9132 16.5734H1.71323C1.60714 16.5734 1.5054 16.5313 1.43039 16.4563C1.35538 16.3813 1.31323 16.2795 1.31323 16.1734C1.31323 14.6429 1.92125 13.175 3.00352 12.0927ZM7.08423 9.40244C5.28845 9.40244 3.56622 10.1158 2.29641 11.3856C1.0266 12.6554 0.313232 14.3777 0.313232 16.1734C0.313232 16.5447 0.460732 16.9008 0.723283 17.1634C0.985835 17.4259 1.34193 17.5734 1.71323 17.5734H12.9132C13.0971 17.5734 13.2791 17.5372 13.449 17.4669C13.6188 17.3965 13.7732 17.2934 13.9032 17.1634C14.0332 17.0334 14.1363 16.879 14.2067 16.7092C14.277 16.5393 14.3132 16.3573 14.3132 16.1734C14.3132 14.3777 13.5999 12.6554 12.3301 11.3856C11.0602 10.1158 9.33801 9.40244 7.54223 9.40244H7.08423Z",
                                fill: "#203136",
                              },
                            }),
                          ]
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.window.width <= 1240
                  ? _c("menu-button", {
                      attrs: {
                        label: this.$store.state.mobile_menu ? "Close" : "Menu",
                        type: this.$store.state.mobile_menu ? "close" : "open",
                      },
                      nativeOn: {
                        click: function ($event) {
                          return _vm.toggleMobileMenu()
                        },
                      },
                    })
                  : _vm._e(),
              ],
              2
            ),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "bounce" } }, [
        _vm.isScrolled && _vm.window.width < 1240
          ? _c(
              "div",
              { staticClass: "mobile_menu_nav scrolled container alt" },
              [
                _c(
                  "a",
                  { staticClass: "site_header-brand", attrs: { href: "/" } },
                  [
                    _c("img", {
                      attrs: {
                        src: _vm.parsedGlobalSettings.general.logo
                          ? _vm.parsedGlobalSettings.general.logo
                          : _vm.logo,
                        alt: "Property Insurance People",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "right" },
                  [
                    _vm.parsedGlobalSettings
                      ? _c("primary-button", {
                          attrs: {
                            link: _vm.parsedGlobalSettings.general.cta,
                            label: _vm.parsedGlobalSettings.general.cta.title,
                            target: _vm.parsedGlobalSettings.general.cta.target,
                          },
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(
                      _vm.parsedSecondaryMenu,
                      function (menu_item, index) {
                        return [
                          menu_item["classes"].includes("portal_logins")
                            ? _c("secondary-menu-item", {
                                key: index,
                                attrs: {
                                  menu_item: menu_item,
                                  "has-children": menu_item.children
                                    ? true
                                    : false,
                                  selected:
                                    menu_item.object_id ==
                                    Number(_vm.currentId),
                                  locale: _vm.locale,
                                  type: "mobile",
                                  theme: menu_item["classes"].includes(
                                    "portal_logins"
                                  )
                                    ? "portal"
                                    : "top",
                                },
                              })
                            : _vm._e(),
                        ]
                      }
                    ),
                    _vm._v(" "),
                    _vm.parsedGlobalSettings.general.portal_login
                      ? _c(
                          "a",
                          {
                            staticClass: "portal_link",
                            attrs: {
                              href: _vm.parsedGlobalSettings.general
                                .portal_login.url,
                              target:
                                _vm.parsedGlobalSettings.general.portal_login
                                  .target,
                            },
                          },
                          [
                            _c(
                              "svg",
                              {
                                attrs: {
                                  width: "15",
                                  height: "18",
                                  viewBox: "0 0 15 18",
                                  fill: "none",
                                  xmlns: "http://www.w3.org/2000/svg",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M4.64624 3.90342C4.64624 2.43048 5.8403 1.23642 7.31324 1.23642C8.78618 1.23642 9.98024 2.43048 9.98024 3.90342C9.98024 5.37636 8.78618 6.57042 7.31324 6.57042C5.8403 6.57042 4.64624 5.37636 4.64624 3.90342ZM7.31324 0.23642C5.28801 0.23642 3.64624 1.87819 3.64624 3.90342C3.64624 5.92865 5.28801 7.57042 7.31324 7.57042C9.33847 7.57042 10.9802 5.92865 10.9802 3.90342C10.9802 1.87819 9.33847 0.23642 7.31324 0.23642ZM3.00352 12.0927C4.08579 11.0104 5.55367 10.4024 7.08423 10.4024H7.54223C9.0728 10.4024 10.5407 11.0104 11.6229 12.0927C12.7052 13.175 13.3132 14.6429 13.3132 16.1734C13.3132 16.226 13.3029 16.278 13.2828 16.3265C13.2627 16.375 13.2332 16.4191 13.1961 16.4563C13.1589 16.4934 13.1148 16.5229 13.0663 16.543C13.0178 16.5631 12.9658 16.5734 12.9132 16.5734H1.71323C1.60714 16.5734 1.5054 16.5313 1.43039 16.4563C1.35538 16.3813 1.31323 16.2795 1.31323 16.1734C1.31323 14.6429 1.92125 13.175 3.00352 12.0927ZM7.08423 9.40244C5.28845 9.40244 3.56622 10.1158 2.29641 11.3856C1.0266 12.6554 0.313232 14.3777 0.313232 16.1734C0.313232 16.5447 0.460732 16.9008 0.723283 17.1634C0.985835 17.4259 1.34193 17.5734 1.71323 17.5734H12.9132C13.0971 17.5734 13.2791 17.5372 13.449 17.4669C13.6188 17.3965 13.7732 17.2934 13.9032 17.1634C14.0332 17.0334 14.1363 16.879 14.2067 16.7092C14.277 16.5393 14.3132 16.3573 14.3132 16.1734C14.3132 14.3777 13.5999 12.6554 12.3301 11.3856C11.0602 10.1158 9.33801 9.40244 7.54223 9.40244H7.08423Z",
                                    fill: "#203136",
                                  },
                                }),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.window.width <= 1240
                      ? _c("menu-button", {
                          attrs: {
                            label: this.$store.state.mobile_menu
                              ? "Close"
                              : "Menu",
                            type: this.$store.state.mobile_menu
                              ? "close"
                              : "open",
                          },
                          nativeOn: {
                            click: function ($event) {
                              return _vm.toggleMobileMenu()
                            },
                          },
                        })
                      : _vm._e(),
                  ],
                  2
                ),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _vm.window.width <= 1240
        ? _c("mobile-menu", {
            class: { alert_open: this.$store.state.alert_bar_closed === false },
            attrs: {
              "is-showing": this.$store.state.mobile_menu,
              "current-id": Number(_vm.currentId),
              "menu-data": _vm.parsedMenu,
              "sec-menu-data": _vm.parsedSecondaryMenu,
              "global-settings": _vm.parsedGlobalSettings,
            },
            on: { "trigger-toggle-search": _vm.emittedToggleSearch },
          })
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.searchToggled
          ? _c(
              "div",
              {
                ref: "container",
                staticClass: "search_dropdown",
                class: { scrolled: _vm.isScrolled },
              },
              [
                _c("div", { staticClass: "container" }, [
                  _c(
                    "div",
                    { staticClass: "inner" },
                    [
                      _c("div", { staticClass: "search_form" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "18",
                              height: "18",
                              viewBox: "0 0 18 18",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                "fill-rule": "evenodd",
                                "clip-rule": "evenodd",
                                d: "M7.85544 2.44576C4.72582 2.44576 2.18877 4.98281 2.18877 8.11242C2.18877 11.2421 4.72581 13.7791 7.85544 13.7791C9.31113 13.7791 10.6386 13.2302 11.6422 12.3281L12.0711 11.8992C12.9732 10.8956 13.5221 9.56811 13.5221 8.11242C13.5221 4.9828 10.9851 2.44576 7.85544 2.44576ZM13.9376 12.7804C14.9313 11.4876 15.5221 9.86903 15.5221 8.11242C15.5221 3.87825 12.0897 0.445755 7.85544 0.445755C3.62125 0.445755 0.188766 3.87824 0.188766 8.11242C0.188766 12.3467 3.62126 15.7791 7.85544 15.7791C9.61204 15.7791 11.2307 15.1883 12.5234 14.1946L16.1888 17.86L17.603 16.4458L13.9376 12.7804Z",
                                fill: "#4F58F5",
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "form",
                          {
                            attrs: {
                              role: "search",
                              action: "/",
                              method: "GET",
                            },
                          },
                          [
                            _c("input", {
                              ref: "search",
                              attrs: {
                                type: "text",
                                name: "s",
                                value: "",
                                placeholder: "Type to search...",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("close-button", {
                        attrs: { type: "grey" },
                        nativeOn: {
                          click: function ($event) {
                            return _vm.toggleSearch.apply(null, arguments)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ]
            )
          : _vm._e(),
      ]),
      _vm._v(" "),
      _c(
        "transition-group",
        {
          staticClass: "search-outer-wrapper",
          attrs: { name: "slide-fade-vert" },
        },
        [
          _vm.showSearch && _vm.window.width >= 1240
            ? _c("div", { key: 1, staticClass: "search-outer nectar" }, [
                _c("div", { staticClass: "search" }, [
                  _c(
                    "div",
                    {
                      staticClass: "container",
                      staticStyle: { position: "relative" },
                    },
                    [
                      _c("div", { staticClass: "searchbox" }, [
                        _c("div", { staticClass: "inner-wrap" }, [
                          _c("div", { staticClass: "col span_12" }, [
                            _c(
                              "form",
                              {
                                attrs: {
                                  role: "search",
                                  action: "/",
                                  method: "GET",
                                },
                              },
                              [
                                _c("input", {
                                  ref: "search",
                                  attrs: {
                                    type: "text",
                                    name: "s",
                                    value: "",
                                    placeholder: "Search",
                                  },
                                }),
                                _vm._v(" "),
                                _c("span", [
                                  _vm._v("Hit enter to search or ESC to close"),
                                ]),
                              ]
                            ),
                          ]),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          staticClass: "close",
                          on: {
                            click: function ($event) {
                              _vm.showSearch = !_vm.showSearch
                            },
                          },
                        },
                        [
                          _c("a", { attrs: { href: "#" } }, [
                            _c("span", { staticClass: "close-wrap" }, [
                              _c("span", {
                                staticClass: "close-line close-line1",
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "close-line close-line2",
                              }),
                            ]),
                          ]),
                        ]
                      ),
                    ]
                  ),
                ]),
              ])
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.window.width <= 1240 && this.$store.state.mobile_menu
          ? _c("div", { staticClass: "overlay" })
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }